export default "__VITE_ASSET__yJ0MWQ$5__"